module.exports = __webpack_public_path__ + "static/qathet-3f344372f98eb6bd10a30e110d9a18a7.svg";